import { useCallback } from 'react';

import type { FeatureLayer, GateStatus } from './types';
import { analytics } from './facade';
import { useLiveGate, useLiveGateStatus } from './gate-registry';

/** Reactive feature gate for components. */
export function useFeatureGate(name: string): boolean {
    return useLiveGate(name);
}

/** Tri-state reactive gate: 'pending' until the gate source has values (from
 *  its cache or the backend), then 'on' or 'off'. Independent of analytics
 *  consent, so it needs no ConsentProvider. */
export function useFeatureGateStatus(name: string): GateStatus {
    return useLiveGateStatus(name);
}

/**
 * Returns a stable `track` function. Delegates to the imperative facade so the
 * same code path is used from React and non-React call sites.
 */
export function useTrackEvent(): FeatureLayer['track'] {
    return useCallback<FeatureLayer['track']>((event, value, metadata) => {
        analytics.track(event, value, metadata);
    }, []);
}
